import { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { UserContext } from "../contexts/user";
import { GroupContext } from "../contexts/group";
import { getBlockStatus, getBlockStatus360, getBlockStatusTIM } from "../axios/axiosFunctions";
import { Box, Typography } from "@mui/material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';

const BlockCard = ({block,assessmentId,assessment360}) => {

    const {slugAssessment}=useParams();
    const {currentUser} = useContext(UserContext);
    const {currentGroup} = useContext(GroupContext);
    const [blockStatus, setBlockStatus] = useState(false);

    useEffect(() => {
        const getStatus = async()=>{
            if(currentGroup){
                const status = await getBlockStatusTIM(block._id,assessmentId,currentUser._id,currentGroup._id);
                setBlockStatus(status.completed);
            }else{
                let status;
                if(assessment360){
                    status = await getBlockStatus360(block._id,assessmentId,currentUser._id);
                }else{
                    status = await getBlockStatus(block._id,assessmentId,currentUser._id);
                }
                setBlockStatus(status.completed);
            }
        }
        getStatus();
    }, [block,assessmentId]);

    return (
    <Box component={blockStatus !== "blocked" && Link} to={blockStatus !== "blocked" ? `/${slugAssessment}/${block.slug}`:""} sx={{backgroundColor:block.color,padding:"35px 40px",display:"flex", justifyContent:"space-between",alignItems:"center",borderRadius:"10px", marginBottom:"20px",textDecoration:"none"}}>
        <Typography variant="h5" fontWeight={"500"} color="white" dangerouslySetInnerHTML={{ __html: block?.name }}/>
        {
            blockStatus === "completed" && 
            <CheckCircleIcon className="invertIconBlock"/>
        }
        {
            blockStatus === "blocked" && <PendingIcon className="invertIconBlock"/>
        }
        {
            blockStatus === "empty" && 
            <ArrowForwardIcon className="invertIconBlock"/>
        }
    </Box>
    )
}

export default BlockCard